import { render } from "./InputsInformations.vue?vue&type=template&id=c63b35c2&scoped=true"
import script from "./InputsInformations.vue?vue&type=script&lang=js"
export * from "./InputsInformations.vue?vue&type=script&lang=js"

import "./InputsInformations.vue?vue&type=style&index=0&id=c63b35c2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c63b35c2"]])

export default __exports__